/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  faCheckCircle,
  faCircle,
  faXmarkCircle
} from '@fortawesome/free-regular-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Timeline from 'components/base/Timeline';
// import { TimelineItem } from 'data/timelineData';
import { Button, Col, Row } from 'react-bootstrap';
import Badge from 'components/base/Badge';
import noData from 'assets/img/illustration/no_data.svg';

import { Link } from 'react-router-dom';
import { useState } from 'react';
import useFetchData from 'hooks/custom/useFetchData';
import apiEndpoints from 'constants/apiEndpoints';
import { getLeaveStatus, leaveStatus } from 'helpers/status-badge';
import { formatDate } from 'services/utils';
import StatusBadge from 'components/custom/ui/StatusBadge';

export const timelineData = [
  // {
  //   id: 14,
  //   time: '3:00pm',
  //   icon: faCircle,
  //   iconColor: 'warning',
  //   fromDate: '10 September 2024',
  //   toDate: '12 September 2024',
  //   totalDays: 3,
  //   leaveType: 'Casual Leave',
  //   approval: 'Pending',
  //   reason: 'i have some personal work'
  // },
  // {
  //   id: 16,
  //   time: '6:00pm',
  //   icon: faCheckCircle,
  //   iconColor: 'success',
  //   fromDate: '5 March 2024',
  //   toDate: '15 March 2024',
  //   totalDays: 11,
  //   leaveType: 'Casual Leave',
  //   approval: 'Approved',
  //   reason: 'i have some personal work'
  // },
  // {
  //   id: 15,
  //   time: '4:00pm',
  //   icon: faCheckCircle,
  //   iconColor: 'success',
  //   fromDate: '2 January 2024',
  //   toDate: '6 January 2024',
  //   totalDays: 5,
  //   leaveType: 'Emergency Leave',
  //   approval: 'Approved',
  //   reason: 'i have some personal work'
  // },
  // {
  //   id: 13,
  //   time: '1:00pm',
  //   icon: faXmarkCircle,
  //   iconColor: 'danger',
  //   fromDate: '12 November 2024',
  //   toDate: '13 November 2024',
  //   totalDays: 2,
  //   leaveType: 'Half Day',
  //   approval: 'Rejected',
  //   reason: 'i have some personal work'
  // },
  // {
  //   id: 12,
  //   time: '12:00pm',
  //   icon: faXmarkCircle,
  //   iconColor: 'danger',
  //   fromDate: '3 October 2024',
  //   toDate: '6 October 2024',
  //   totalDays: 4,
  //   leaveType: 'Sick leave',
  //   approval: 'Rejected',
  //   reason: 'i have some personal work'
  // },
  // {
  //   id: 11,
  //   time: '9:00am',
  //   icon: faCheckCircle,
  //   iconColor: 'success',
  //   fromDate: '2 july 2024',
  //   toDate: '4 july 2024',
  //   totalDays: 3,
  //   leaveType: 'Casual Leave',
  //   approval: 'Approved',
  //   reason: 'i have some personal work'
  // }
];

const LeaveRequests = ({ userId, employeeId }) => {
  const [employeeLeaveData] = useFetchData(
    apiEndpoints.leave.employeeleaveDetail(employeeId)
  );
  console.log(
    '🚀 ~ LeaveRequests ~ employeeLeaveData:',
    employeeLeaveData.leave_data
  );
  return (
    <div className="card card-body  ">
      <h4 className="mb-3">Leave Requests</h4>
      <div
        className="scrollbar w-100"
        style={{ maxHeight: '400px', overflowX: 'hidden' }}
      >
        {employeeLeaveData?.leave_data?.length > 0 ? (
          <>
            <div>
              <LeaveBasicTimeline
                action={false}
                data={employeeLeaveData?.leave_data || []}
              />
            </div>
          </>
        ) : (
          <div className="p-4 text-center">
            <img src={noData} width={'100px'} height={'100px'} />
            <p className="mt-3 text-700">No Leave Requests</p>
          </div>
        )}
      </div>
    </div>
  );
};

const LeaveBasicTimeline = ({ data, action = true }) => {
  return (
    <Timeline variant="basic" className="mb-9">
      {data.map((item, index) => (
        <Timeline.Item key={item.leave_id}>
          <Row className="g-3">
            <Col xs="auto">
              <Timeline.Separator className="position-relative">
                <Timeline.Dot className="icon-item-md bg-soft border">
                  <FontAwesomeIcon
                    icon={leaveStatus(item.status).icon}
                    className={`fs-9 text-${leaveStatus(item.status).color}`}
                  />
                </Timeline.Dot>
                {index !== data.length - 1 && (
                  <Timeline.Bar className="h-50 border-dashed border-400" />
                )}
              </Timeline.Separator>
            </Col>
            <Col className="border-bottom border-300 mt-4">
              <Timeline.Content>
                <div className="d-flex justify-content-between">
                  <div className="d-flex">
                    <h6
                      className="lh-sm mb-0 me-2 text-800 timeline-item-title"
                      // dangerouslySetInnerHTML={{ __html: item.fromDate }}
                    >
                      {formatDate(item.leave_from, 'DD MMM YYYY')} -
                      {formatDate(item.leave_to, 'DD MMM YYYY')}
                    </h6>

                    {item.file && (
                      <h6 className="mb-0 fs-9">
                        <FontAwesomeIcon
                          icon={faFilePdf}
                          className="me-1 text-700"
                        />
                        <Link to="#!">{item.file}</Link>
                      </h6>
                    )}
                  </div>
                  <div className="text-500 fs-9 text-nowrap timeline-time">
                    {/* <Badge variant="phoenix" bg={`${item.iconColor}`}>
                      {item.status}
                    </Badge> */}
                    <StatusBadge
                      // flag={original.change_flag}
                      status={item.status}
                      // lastComment={original.last_comment}
                      getStatus={getLeaveStatus}
                    />
                  </div>
                </div>

                <h6 className="d-flex">
                  <div className="text-primary">{item.leave_type}</div>
                  <ul className="text-500 mb-2 ms-4 p-0 ">
                    <li>{item.days} Days</li>
                  </ul>
                </h6>

                <div className="d-flex justify-content-between align-items-end">
                  <p
                    className={classNames('fs-9 text-800 w-sm-60 mb-0 mt-2', {
                      'mb-1': index !== data.length - 1
                    })}
                  >
                    <b>Reason:</b> {item.reason || ''}
                  </p>
                  {/* {item.status === 'Pending' && action && (
                    <div className="mb-1">
                      <Button
                        variant="primary"
                        className="btn-sm p-1 mb-1"
                        disabled
                      >
                        Review
                      </Button>
                    </div>
                  )} */}
                </div>
              </Timeline.Content>
            </Col>
          </Row>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default LeaveRequests;
